export default __webpack_public_path__ + "static/media/sidebar-collapse.50d1fb71.svg";